var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage---D---M",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A9CBBF",
    cx: 9,
    cy: 9,
    r: 8.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.008,10.888 C9.456,10.888 9.6,10.588 9.728,10.248 C9.97401564,9.56991456 10.413482,8.97886014 10.992,8.548 C11.8274398,7.95088107 12.3409906,7.00199263 12.384,5.976 C12.39539,5.14925268 12.0585943,4.35582316 11.4559639,3.78971584 C10.8533335,3.22360851 10.040423,2.93701089 9.216,3 C8.0861761,2.95163823 7.00222311,3.45043528 6.304,4.34 C6.11974199,4.55453672 6.01394661,4.82537289 6.004,5.108 C5.9994423,5.30328808 6.07281108,5.49235752 6.20790352,5.63345407 C6.34299597,5.77455063 6.52869835,5.85606662 6.724,5.86 C7.00558056,5.8522824 7.26618093,5.70932448 7.424,5.476 C7.80536111,4.95409156 8.40967715,4.64156537 9.056,4.632 C9.45743799,4.61228155 9.84866252,4.76229336 10.1340033,5.04535147 C10.4193442,5.32840957 10.5724935,5.71841658 10.556,6.12 C10.4701048,6.81244469 10.1007336,7.43820299 9.536,7.848 C8.85946782,8.41876816 8.42485313,9.22509278 8.32,10.104 C8.32,10.568 8.56,10.888 9.008,10.888 Z M9.072,14.152 C9.69939548,14.152 10.208,13.6433955 10.208,13.016 C10.208,12.3886045 9.69939548,11.88 9.072,11.88 C8.44460452,11.88 7.936,12.3886045 7.936,13.016 C7.936,13.6433955 8.44460452,14.152 9.072,14.152 Z",
    id: "Path_95",
    fill: "#A9CBBF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.12cbdb3fbd86df6b6730831ada148f46.svg";
export { ForwardRef as ReactComponent };